import type { Router } from "vue-router";
import { useUserStore } from "@/stores/user";

/** Cognito post-auth: mirrors Frontegg HomeView — incomplete profile → AddCompanyDetails. */
export function companyPostAuthRedirect(
  router: Router,
  hasCompany: boolean,
  personalInfoRequired = false
) {
  if (!hasCompany || personalInfoRequired) {
    void router.push({
      name: "AddCompanyDetails",
      query: { pendingCompanyDetails: (!hasCompany).toString() },
    });
  } else {
    void router.push({ name: "SignInLanding" });
  }
}

/**
 * Home (`/`): when Cognito + Rails session exists but job title is missing, send the user to
 * the same AddCompanyDetails route as after Cognito callback (personal details: name + title).
 */
export function companyCognitoHomeRedirectIfPersonalDetailsIncomplete(
  router: Router
): boolean {
  const userStore = useUserStore();
  if (!userStore.token) {
    return false;
  }
  if (userStore.title?.trim()) {
    return false;
  }
  const hasCompany = Boolean(
    (userStore.companyId && String(userStore.companyId).trim()) ||
      (userStore.companyName && userStore.companyName.trim())
  );
  companyPostAuthRedirect(router, hasCompany, true);
  return true;
}
